import essApi from "../axios/essApi";

class AllocationService {
  async getProjects() {
    return Promise.resolve(essApi.get(`projects`));
  }
  async getTimelineWithFilter(body) {
    return Promise.resolve(essApi.post(`allocation-by-user`, body));
  }
  async getActiveProjects() {
    return Promise.resolve(essApi.get(`get-all-active-projects`));
  }
  // async getAllocationType() {
  //     return Promise.resolve(essApi.get(`allocation-type`));
  // }
  async createAllocation(payload) {
    return Promise.resolve(essApi.post(`allocation`, payload));
  }
  async createManagerAllocation(payload) {
    return Promise.resolve(essApi.post(`manager-allocation`, payload));
  }
  async updateManagerAllocation(payload) {
    return Promise.resolve(essApi.put(`allocation/${payload.id}`, payload));
  }
  async getAllocationtypes() {
    return Promise.resolve(essApi.get(`allocation-type`));
  }
  //Get All Resource Role
  async getAllResourceRole(proId) {
    return Promise.resolve(essApi.get(`projectRole?projectId=${proId}`));
  }
  //Get All Billing Roate
  async getAllBillingRate(roleId) {
    return Promise.resolve(essApi.get(`billingrate?projectRoleId=${roleId}`));
  }

  /* Manager - Get all allocations for approval start */
  async getAllAllocationApprovals() {
    return Promise.resolve(essApi.get(`my-allocation-approval`));
  }
  /* Manager - Get all allocations for approval end */

  /* Update Allocation Approval Start */
  async updateAllocationApproval(param) {
    return Promise.resolve(essApi.put(`update-allocation-approval`, param));
  }
  /* Update Allocation Approval end */

  /*Reject allocation start*/
  async updateAllocationReject(payload) {
    return Promise.resolve(essApi.put(`reject-allocation`, payload));
  }
  /*Reject allocation end*/

  /*Update allocation start*/
  async updateAllocation(payload) {
    return Promise.resolve(essApi.put(`update-allocation`, payload));
  }
  /*Update allocation end*/

  /*Get all project by RM*/
  async getAllProjectByUser() {
    return Promise.resolve(essApi.get(`projects-by-user?myProject=true`));
  }
  /*Get all project by RM*/

  async getAllUsersOnBench(payload) {
    return Promise.resolve(essApi.post(`users/onBench`, payload));
  }

  /* Function for get BU Allocated Users */
  async getBUAllocatedUsers(payload) {
    return Promise.resolve(
      essApi.get(`users/allocatedProject/${payload.queryString}`)
    );
  }
  /* Function for get BU Allocated Users */

  /* Function for get allocation by poject start */
  async getAllocationByProject(projectId) {
    return Promise.resolve(
      essApi.get(`allocationByProject?projectId=${projectId}`)
    );
  }
  /* Function for get allocation by poject start */

  /* Function for get timeline by poject start */
  async getTimelineByProject(projectId) {
    return Promise.resolve(
      essApi.get(`projectMilestone?projectId=${projectId}`)
    );
  }
  /* Function for get timeline by poject start */

  /* Function for update project milestone start */
  async updateProjectMilestone(payload) {
    return Promise.resolve(essApi.put(`project-status`, payload));
  }
  /* Function for update project milestone end */

  /* Function for complete milestone status start */
  async completeMilestone(payload) {
    return Promise.resolve(essApi.put(`milestone-status`, payload));
  }
  /* Function for complete milestone status end */

  /* Function for complete milestone status start */
  async getProjectComplationPercentage(projectId) {
    return Promise.resolve(essApi.get(`project-status?projectId=${projectId}`));
  }
  /* Function for complete milestone status end */

  /* Function for update project end date start */
  async updateProjectEndDate(param) {
    return Promise.resolve(essApi.put(`project-completion`, param));
  }
  /* Function for update project end date end */

  /* Function for update project po number start */
  async updateProjectPoNumber(param) {
    return Promise.resolve(essApi.put(`poProjects`, param));
  }
  /* Function for update project po number end */


  /* Function for delete allocation start */
  async deleteAllocationRole(param) {
    return Promise.resolve(essApi.post(`delete_allocation_role`, param));
  }
  /* Function for delete allocation end */

}

export default AllocationService;
